export default __webpack_public_path__ + "static/schuss-schotter-logo-cdcd0e503dced7cd8a9a7ee26a86c129.svg";